import GetNamespaceByIdRequest from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdRequest";
import GetNamespaceByIdResponse from "@/api/Main/dataSource/api/projects/groups/i-service/model/namespaces/GetNamespaceByIdResponse";
import { SaveAdminsModel, UserModel } from "../models";
import UpsertNamespaceAdminListRequest from "@/api/Main/dataSource/api/projects/performers/i-service/model/namespace-admins/UpsertNamespaceAdminListRequest";
import UpsertNamespaceAdminListRequestItem from "@/api/Main/dataSource/api/projects/performers/i-service/model/namespace-admins/UpsertNamespaceAdminListRequestItem";
import GetEmployeesForManagerListWithAccessResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/GetEmployeesForManagerListWithAccessResponse";
import GetOwnedUsersWithAccessResponse from "@/api/Main/dataSource/api/projects/performers/i-service/model/response/GetOwnedUsersWithAccessResponse";

export const mapGetNamespaceAdminsRequest = (namespaceId: string) =>
  new GetNamespaceByIdRequest({
    NamespaceId: namespaceId,
  });

export const mapGetNamespaceAdminsResponse = (response: GetNamespaceByIdResponse) =>
  response.AdminList.map(
    (user) =>
      new UserModel({
        Id: user.UserId,
        FirstName: user.FirstName,
        LastName: user.LastName,
        MiddleName: user.MiddleName,
        Photo: user.Foto,
        AvatarColor: user.AvatarColor,
        CanCustomizeOrder: user.CanCustomizeOrder,
      }),
  );

export const mapGetEmployeesResponse = (response: GetEmployeesForManagerListWithAccessResponse) =>
  response.Items.map(
    (item) =>
      new UserModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Photo: item.Foto,
        IsProjectAdmin: item.IsProjectAdmin,
        IsNamespaceAdmin: item.IsNamespaceAdmin
      }),
  );

export const mapGetOwnedUsersResponse = (response: GetOwnedUsersWithAccessResponse) =>
  response.Items.map(
    (item) =>
      new UserModel({
        Id: item.UserId,
        FirstName: item.FirstName,
        LastName: item.LastName,
        MiddleName: item.MiddleName,
        Photo: item.Foto,
        AvatarColor: item.AvatarColor,
        IsProjectAdmin: item.IsProjectAdmin,
        IsNamespaceAdmin: item.IsNamespaceAdmin
      }),
  );

export const mapSaveNamespaceAdminsRequest = (request: SaveAdminsModel) =>
  new UpsertNamespaceAdminListRequest({
    NamespaceId: request.NamespaceId,
    AdminList: request.Admins.map(
      (admin) =>
        new UpsertNamespaceAdminListRequestItem({
          UserId: admin.Id,
          CanCustomizeOrder: admin.CanCustomizeOrder,
        }),
    ),
    RemoveQueueTasksAccess: request.RemoveQueueTasksAccess,
    RemoveTaskObserver: request.RemoveTaskObserver,
    RemoveTaskPerformer: request.RemoveTaskPerformer
  });
